/**
 * Datos simulados determinísticos por userId (solo UI hasta tener API).
 */
const CHAINS = ['Falabella', 'Lider', 'Jumbo', 'Tottus', 'SISA', 'Unimarc', 'Cencosud', 'SMU']

function prng (seed) {
  let s = Math.abs(seed) % 2147483646 || 1
  return () => {
    s = (s * 16807) % 2147483647
    return (s - 1) / 2147483646
  }
}

function formatStay (minutes) {
  if (minutes < 60) return `${minutes} min`
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return m > 0 ? `${h}h ${m}min` : `${h}h`
}

function storeName (rand, idx) {
  const chain = CHAINS[Math.floor(rand() * CHAINS.length)]
  const num = 1800 + Math.floor(rand() * 900) + idx * 17
  return `${chain} - ${num}`
}

/** Coordenadas simuladas en zona Santiago (determinísticas). */
function storeLatLng (userId, dayOffset, storeIdx) {
  let s = (Number(userId) * 7919 + dayOffset * 13 + storeIdx * 17) % 2147483646 || 1
  const n = () => {
    s = (s * 16807) % 2147483647
    return (s - 1) / 2147483646
  }
  return {
    latitude: -33.42 + n() * 0.12,
    longitude: -70.72 + n() * 0.1
  }
}

export function buildMockFieldUserInsights (userId) {
  const r = prng(Number(userId) || 1)

  const monthlyGoal = 55 + Math.floor(r() * 50)
  const visitedThisMonth = Math.max(
    0,
    Math.min(
      monthlyGoal + 12,
      monthlyGoal - 15 + Math.floor(r() * 35)
    )
  )
  const storesVisitedToday = 1 + Math.floor(r() * 6)
  const avgStoresPerDay = Math.round((25 + r() * 35) / 10) / 10 + 2
  const avgStayMinutes = 28 + Math.floor(r() * 52)

  const countDay1 = 3 + Math.floor(r() * 4)
  const countDay2 = 2 + Math.floor(r() * 5)
  const storesDay1 = Array.from({ length: countDay1 }, (_, i) => ({
    id: `${userId}-d1-${i}`,
    name: storeName(r, i),
    ...storeLatLng(userId, 1, i)
  }))
  const storesDay2 = Array.from({ length: countDay2 }, (_, i) => ({
    id: `${userId}-d2-${i}`,
    name: storeName(r, i + 10),
    ...storeLatLng(userId, 2, i)
  }))

  return {
    monthlyGoal,
    visitedThisMonth: Math.max(0, visitedThisMonth),
    storesVisitedToday,
    avgStoresPerDay,
    avgStayInStore: formatStay(avgStayMinutes),
    avgStayMinutes,
    routes: [
      { offset: 1, stores: storesDay1 },
      { offset: 2, stores: storesDay2 }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/news_feed/utils/mockFieldUserInsights.js